exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".submitrow{margin-top:2em}.invisible{visibility:hidden}.tag{display:inline-block;color:#222;background-color:#fafafa;border:1px solid #95a5a6;padding:2px 8px;margin:1px 2px;border-radius:7px;white-space:nowrap;cursor:default}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/app/pages/sales-details-report/sales-details-report.scss
// module id = 1328
// module chunks = 0